import React from 'react'

const Footer = () => {
  return (
    <footer className="bg-main-green mt-4 w-full h-12 md:h-10 absolute left-0 bottom-0 flex flex-col md:flex-row justify-center items-center italic text-xs">
      <p>© 2023&nbsp;<a className="underline" href="https://github.com/annalemonbcn">annalemonbcn</a>.</p>
      <p>Web development from Barcelona.</p>
    </footer>
  )
}

export default Footer